function formatExperience (val) {
  return Number(val).toLocaleString('en-US') + ' XP'
}

export {
  formatExperience
}
